

type Props = {
  page: number,
  onPageChange: (type: string) => void
}


const Pagination = ({ onPageChange, page }: Props) => {

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginTop: '20px',
      gap: '10px'
    }}>
      <button
        className={`rounded-lg ${page === 1 ? 'disabled bg-gray-500' : ''}`}
        onClick={() => onPageChange('back')}
        style={{
          backgroundColor: '#000',
          border: 'none',
          cursor: 'pointer',
          padding: '6px 16px',
          color: 'white',
          borderRadius: 6,
        }}
      >
        Back
      </button>
      <span>{page}</span>
      <button
        className="rounded-lg"
        onClick={() => onPageChange('next')}
        style={{
          backgroundColor: '#000',
          border: 'none',
          cursor: 'pointer',
          padding: '6px 16px',
          color: 'white',
          borderRadius: 6,
        }}
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;